import { Unit } from "uom";
export var CelsiusDewPoint = Unit.createBase("CelsiusDewPoint", "DewPointTemperature", "dp°C");
export var FahrenheitDewPoint = Unit.minus("FahrenheitDewPoint", 32.0, Unit.timesNumber("", 5.0 / 9.0, CelsiusDewPoint));
export var KelvinDewPoint = Unit.minus("KelvinDewPoint", 273.15, CelsiusDewPoint);
//# sourceMappingURL=dew-point-temperature.js.map